/* eslint-disable no-use-before-define */
import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import clientService from '../../../Services/clientService';
import AuthService from '../../../Services/authService';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

class EditClientWindowDescription extends React.Component {
  static titleForCreate = 'Add New Client';
  static titleForEdit = 'Edit Client';
  static entityName = 'Client';
  static idField = 'ClientId';
  static ComponentName = 'Client';
  static itemType = EditClientWindowDescription.getItemType;
  static serviceFunction = (edited) => clientService.EditClient(edited);

  static getItemType() {
    // eslint-disable-next-line global-require
    return require('../../../Domain/ClientItem').default;
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IndustryCode',
          label: 'Industry *',
          className: 'col-12',
          type: InputTypesEnum.IndustryLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ContactId',
          label: 'Primary Contact',
          className: 'col-12',
          type: InputTypesEnum.ContactSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: (item) => item.ClientId === '',
          idFilter: 'ClientId',
        },
        {
          fieldName: 'OfficeId',
          label: 'Office *',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'IsMspartner',
          label: 'MS Partner',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'MspartnerCode',
          label: 'MS Partner',
          className: 'col-12',
          type: InputTypesEnum.MsPartnerSelect,
          validityChecker: EditClientWindowDescription.validityCheckerMsPartner,
          hide: (item) => item.IsMspartner !== true,
        },
        {
          fieldName: 'Vatnumber',
          label: 'Tax Number *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.validityCheckerforVatNumber,
        },
      ],
    },
    {
      label: 'Management',
      fields: [
        {
          fieldName: 'CheckInByDate',
          label: 'Check-in by Date *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredDateLatterThanToday,
        },
        {
          fieldName: 'SalesRepId',
          label: 'Primary Sales Rep',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'ReferralSourceCode',
          label: 'Referral Source *',
          className: 'col-12',
          type: InputTypesEnum.CommonReferralSourceLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'AcctMgrId',
          label: 'Primary Account Mgr',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'StatusCode',
          label: 'Status',
          className: 'col-12',
          type: InputTypesEnum.ClientStatusLookupItemSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
    {
      label: 'Billing',
      fields: [
        {
          fieldName: 'DaysToPayCode',
          label: 'Days To Pay Code',
          className: 'col-12',
          type: InputTypesEnum.InvoiceDaysToPayLookupItemSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'UseSummaryReport',
          label: 'Invoice Form Type',
          className: 'col-12',
          type: InputTypesEnum.InvoiceFormTypeLookupItemSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'InvoiceInterestRate',
          label: 'Late Fee %',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
    {
      label: 'Contact Information',
      fields: [
        {
          fieldName: 'MainPhone',
          label: 'Main Phone',
          className: 'col-12',
          type: InputTypesEnum.BusinessPhone,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'WebSiteUrl',
          label: 'Website Url',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'TimeZoneOffset',
          label: 'Time Zone',
          className: 'col-12',
          type: InputTypesEnum.TimeZone,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
    {
      label: 'Address',
      fields: [
        {
          fieldName: 'AddressId',
          label: 'Address',
          className: 'col-12',
          type: InputTypesEnum.SelectAddressWithInformationByEntityType,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.ClientId === '',
          EntityTypeId: '7',
          EntityId: 'ClientId',
          disableClearButton: true,
        },
        {
          fieldName: 'AddressName',
          label: 'Address Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.ClientId !== '',
        },
        {
          fieldName: 'AddressStreet',
          label: 'Address Street',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.ClientId !== '',
        },
        {
          fieldName: 'Country',
          label: 'Country',
          className: 'col-12',
          type: InputTypesEnum.CountrySelect,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.ClientId !== '',
        },
        {
          fieldName: 'State',
          label: 'State',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.ClientId !== '',
        },
        {
          fieldName: 'City',
          label: 'City',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.ClientId !== '',
        },
        {
          fieldName: 'PostalCode',
          label: 'Postal Code',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.ClientId !== '',
        },
        {
          fieldName: 'AddressTypeId',
          label: 'Address Type',
          className: 'col-12',
          type: InputTypesEnum.AddressTypeLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: (item) => item.ClientId !== '',
        },
        {
          fieldName: 'Comments',
          label: 'Comments',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
    {
      label: 'Details',
      fields: [
        {
          fieldName: 'PrefContactMethodCode',
          label: 'Preferred Contact Method',
          className: 'col-12',
          type: InputTypesEnum.CommonContactMethodLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Level1',
          label: 'Level 1',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Level2',
          label: 'Level 2',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Level3',
          label: 'Level 3',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Level4',
          label: 'Level 4',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Level5',
          label: 'Level 5',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'GroupLabel',
          label: 'Group Label',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'AllowFax',
          label: 'Allow Fax',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'AllowEmail',
          label: 'Allow Email',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'AllowPhone',
          label: 'Allow Phone',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'AllowBulkEmail',
          label: 'Allow Bulk Email',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'AllowPostalMail',
          label: 'Allow Postal Mail',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'AllowSendMedia',
          label: 'Allow Send Media',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'AllowExtendedJobExport',
          label: 'Job Extended Export (Email)',
          className: 'col-12',
          type: InputTypesEnum.PlaceHolder,
          tooltipText:
            'This field can only be accessed by Admins, open an IT ticket if Extended Job Exports are needed for this Client',
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: () => AuthService.IsAdmin(),
          onFieldChange: EditClientWindowDescription.onAllowExtendedJobExportChange,
        },
        {
          fieldName: 'AllowExtendedJobExport',
          label: 'Job Extended Export (Email)',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: () => !AuthService.IsAdmin(),
        },
        {
          fieldName: 'ExtendedJobExportUntilUtc',
          label: 'Extended Export Until',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: EditClientWindowDescription.ExtendedExportUntilValidityChecker,
          disabled: (item) => item.AllowExtendedJobExport !== true,
          hide: () => !AuthService.IsAdmin(),
        },
        {
          fieldName: 'ModifyExtendedJobExportUntilReason',
          label: 'Modify Extension Reason',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
          disabled: (item) => item?.AllowExtendedJobExport !== true,
          hide: (item) =>
            !AuthService.IsAdmin() ||
            !item.ExtendedJobExportUntilUtcOriginal ||
            dateTimeHelper.dateDiffInDays(
              new Date(item.ExtendedJobExportUntilUtcOriginal),
              new Date(item.ExtendedJobExportUntilUtc)
            ) < 1, //Show reason field if it's an Admin user and the ExtendedJobExportUntilUtc has been modified
        },
      ],
    },
  ];

  static validityCheckerMsPartner(e, editedItem) {
    if (editedItem === undefined) {
      return '';
    }
    if (editedItem.IsMspartner === false) {
      return '';
    }
    if (!e || e.toString().trim() === '') {
      return "This field can't be empty.";
    }
    return '';
  }

  static ExtendedExportUntilValidityChecker(e, editedItem) {
    if (editedItem?.AllowExtendedJobExport !== true) {
      return '';
    }
    if (!e) {
      return "This field can't be empty.";
    }

    const now = new Date();
    const selectedDate = new Date(e);
    const originalDate = editedItem.ExtendedJobExportUntilUtcOriginal
      ? new Date(editedItem.ExtendedJobExportUntilUtcOriginal)
      : new Date();

    if (
      dateTimeHelper.dateDiffInDays(selectedDate, originalDate) < 1 &&
      dateTimeHelper.dateDiffInDays(selectedDate, originalDate) > -1
    ) {
      return '';
    }
    if (dateTimeHelper.dateDiffInDays(now, selectedDate) < 1) {
      return 'The date must be in the future.';
    }
    if (dateTimeHelper.dateDiffInDays(originalDate, selectedDate) < 1) {
      return 'The new date must be later than the original extended date.';
    }
    if (dateTimeHelper.dateDiffInDays(dateTimeHelper.addMonthsToDate(now, 13), selectedDate) >= 1) {
      return "The date can't be more than 13 months in the future.";
    }
    return '';
  }

  static onAllowExtendedJobExportChange(editedItem) {
    if (editedItem.AllowExtendedJobExport !== true) {
      editedItem.ExtendedJobExportUntilUtc = null;
    }
  }
}

export default EditClientWindowDescription;
